export default "__VITE_ASSET__D7Gg$Bcc__"